import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { endpoints, fetcher } from 'services';
import { INIT_PAGESIZE } from 'commons/constants';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

const useB2cPml = (defaultPageSize: number) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [pmlList, setPmlList] = useState<B2cPmlListDto[]>();
  const [searchResult, setSearchResult] = useState({ pageNo: 0, pageSize: INIT_PAGESIZE, totalCount: 0 });

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  const { isLoading, refetch } = useQuery(
    [endpoints.b2c.pml.list.ing, location.search],
    () =>
      fetcher.b2c.postProjectPmlIngList({
        pageNo: Number(searchParams.pageNo) || 1,
        pageSize: Number(searchParams.pageSize) || defaultPageSize,
        searchValue: searchParams.search ? String(searchParams.search) : '',  
        searchDateStart: searchParams.searchDateStart ? String(searchParams.searchDateStart) : '',   
        searchDateEnd: searchParams.searchDateEnd ? String(searchParams.searchDateEnd) : '',  
        pm: searchParams.pm ? String(searchParams.pm) : '',  
        company: searchParams.company ? String(searchParams.company) : '',   
        crm: searchParams.crm ? String(searchParams.crm) : '',
        group_id: searchParams.group_id ? Number(searchParams.group_id) : null,  
      }),
    {
      onSuccess: (res: CommonSearchListResDto) => {
        switch (res.code) {
          case 200:
            setPmlList(res.result?.list);
            setSearchResult({
              pageNo: res.result?.pageNo || 1,
              pageSize: res.result?.pageSize || defaultPageSize,
              totalCount: res.result?.totalCount || 0,
            });
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { pmlList, searchResult, refetch };
};

export default useB2cPml;
